/**
 * Add CSS classes to root node according to the device touch capability
 */
export default function touchDeviceDetection() {
    const root = document.querySelector('html');
    const isTouch = (!isDesktop() && (isTablet() || isMobile()));

    // Add a CSS `.is-mac` class on root node if the current device is either Macintosh, Ipad or iPhone
    if(isTouch) {
        root.classList.add('is-touch');
    }
    // Add a CSS `.is-not-mac` class on root node if the current device is not Macintosh, Ipad or iPhone
    else {
        root.classList.add('no-touch');
    }
};


function isDesktop() {
    return (!touchAvailable() && !window.orientation);
}

function isMobile() {
    const max = 1023;
    const biggestScreenSide = (window.screen.width > window.screen.height) ? window.screen.width : window.screen.height;

    return (!isDesktop() && biggestScreenSide <= max);
}

function isTablet() {
    const min = 1024;
    const biggestScreenSide = (window.screen.width > window.screen.height) ? window.screen.width : window.screen.height;

    return (!isDesktop() && biggestScreenSide >= min);
}

function touchAvailable() {
    return !!(("ontouchstart" in window) || (window.DocumentTouch && document instanceof window.DocumentTouch) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
}